(function() {
  // Desktop hover zoom
  function initDesktopZoom() {
    const images = document.querySelectorAll('[data-product-image]');

    images.forEach(img => {
      const wrapper = img.closest('[data-product-image-wrapper]') || img.parentElement;
      if (!wrapper) return;

      let bgImg = new Image();
      bgImg.onload = function() {
        wrapper.style.backgroundImage = `url('${bgImg.src}')`;
        wrapper.style.backgroundSize = '200%';
        wrapper.style.backgroundPosition = '0% 0%';
        wrapper.style.backgroundRepeat = 'no-repeat';
        wrapper.style.cursor = 'zoom-in';
      };
      bgImg.src = img.src;

      wrapper.addEventListener('mouseenter', function() {
        wrapper.style.cursor = 'zoom-in';
      });

      wrapper.addEventListener('mousemove', function(e) {
        if (!wrapper.style.backgroundImage) return;

        const rect = wrapper.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const percentX = (x / rect.width) * 100;
        const percentY = (y / rect.height) * 100;

        wrapper.style.backgroundPosition = `${percentX}% ${percentY}%`;
      });

      wrapper.addEventListener('mouseleave', function() {
        wrapper.style.backgroundPosition = '0% 0%';
        wrapper.style.cursor = 'default';
      });
    });
  }

  // Lightbox handler
  function initLightbox() {
    const images = document.querySelectorAll('[data-product-image]');
    const dialog = document.querySelector('[data-lightbox-dialog]');

    if (!dialog) return;

    images.forEach(img => {
      img.style.cursor = 'pointer';
      img.addEventListener('click', (e) => {
        e.preventDefault();
        const lightboxImg = dialog.querySelector('img');
        if (lightboxImg) {
          lightboxImg.src = img.src;
          lightboxImg.alt = img.alt;
        }
        dialog.showModal?.();
      });
    });

    // Close button
    const closeBtn = dialog.querySelector('[data-lightbox-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        dialog.close?.();
      });
    }

    // Backdrop click
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        dialog.close?.();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    // Only zoom on desktop
    if (window.matchMedia('(min-width: 768px)').matches) {
      initDesktopZoom();
    }
    initLightbox();
  });
})();
